import { isValidPhoneNumber } from '@acceligentllc/shared/utils/phone';

import { EMAIL_REGEX } from '@acceligentllc/shared/constants/regex';

import type * as UserFM from '../formModel';

export function emailValidate(values: UserFM.UserEmailCredentials) {
	const errors: ValidationErrors = {};

	if (!values.email) {
		errors.email = 'Email is required';
	} else if (!EMAIL_REGEX.test(values.email)) {
		errors.email = 'Invalid email address';
	}

	if (!values.password) {
		errors.password = 'Password required';
	}

	return errors;
}

export function phoneValidate(values: UserFM.UserPhoneCredentials) {
	const errors: ValidationErrors = {};

	if (!values.countryCode) {
		errors.countryCode = 'Country code is required';
	}

	if (!values.phoneNumber) {
		errors.phoneNumber = 'Mobile phone is required';
	} else if (!isValidPhoneNumber(values.phoneNumber)) {
		errors.phoneNumber = 'Invalid mobile phone';
	}

	return errors;
}
